import { makeStyles, StyleRules } from '@material-ui/core';
import { EmailType } from './types';

const buttonPadding = '12px';

export const useStylesForm = makeStyles((theme) => ({
  primaryTitle: {
    marginBottom: theme.spacing(4),
    '& >*': {
      marginBottom: theme.spacing(2),
    },
    '& h5': {
      lineHeight: '24px',
    },
  },
  emailTitle: {
    lineHeight: 1.5,
    fontSize: '1.15em',
  },
  otherTitle: {
    maxWidth: '620px',
    '& >*': {
      marginBottom: theme.spacing(2),
    },
    '& h5': {
      lineHeight: '24px',
    },
  },
  unverifiedBlock: {
    '& >*': {
      marginBottom: theme.spacing(3),
    },
    marginBottom: theme.spacing(3),
  },
  verifiedBlock: {
    '& >*': {
      marginBottom: theme.spacing(1),
    },
    marginBottom: theme.spacing(3),
  },
  saveButton: {
    marginRight: theme.spacing(2),
  },
}));

export const useStylesRow = (type = EmailType.Unverified) =>
  makeStyles(() => {
    const main = {
      container: {
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        justifyContent: 'space-between',
        marginBottom: 8,
      },
      primaryEmail: {
        fontWeight: 600,
      },
      email: {
        overflowWrap: 'break-word',
        wordBreak: 'break-word',
        lineHeight: 1.5,
        fontSize: '1.15em',
      },
      label: {
        fontWeight: 600,
        whiteSpace: 'nowrap',
      },
      emailContainer: {
        marginBottom: 8,
      },
      actions: {
        display: 'flex',
        alignItems: 'flex-end',
      },
      makePrimary: { marginRight: 8 },
      notification: {
        width: '100%',
      },
    } as StyleRules;

    switch (type) {
      case EmailType.Primary:
        return main;
      case EmailType.Verified:
        return {
          ...main,
          container: {
            ...main.container,
            marginBottom: 0,
            '&>*': {
              marginBottom: 8,
            },
          },
        };
      default:
        return main;
    }
  })();

export const useStylesAddEmail = makeStyles((theme) => ({
  primaryActions: {
    display: 'flex',
    flexWrap: 'wrap',
    '& button:first-child': {
      marginRight: 16,
    },
    [theme.breakpoints.down(434)]: {
      '& button:first-child': {
        marginBottom: '16px',
      },
    },
  },
  actions: {
    display: 'flex',
    gap: theme.spacing(2),
  },
  input: {
    maxWidth: '358px',
    '& svg': {
      marginLeft: '18px',
    },
    marginBottom: '32px',
  },
}));

export const useStylesEmailList = makeStyles((theme) => ({
  list: {
    padding: 0,
    listStyleType: 'none',
    '& > li': {
      marginBottom: theme.spacing(0.5),
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
    },
    '& > li:last-child': {
      marginBottom: 0,
    },
  },
}));
export const buttonStyles = makeStyles(() => ({
  buttonn: {
    color: '#00588f',
  },
}));
